import { CUSTOM_CSS_KEY } from "../settings/catalog";
import { replaceRules, forInjection } from "../settings/css";
import { usePreviewCss } from "../settings/cssPreview";
import { useSettings } from "../settings/context";

/**
 * LE CSS DEMANDÉ PAR L'ORGANISATEUR, POSÉ SUR SON SITE.
 *
 * ⚠️ RENDU EN PLACE, ET NON HISSÉ DANS LE `<head>`. React 19 sait hisser un `<style>`
 * qui porte `precedence` — mais il le dédoublonne alors par son `href` et ne le remet
 * PAS à jour quand son contenu change : le mécanisme est fait pour des feuilles
 * statiques. Ici le contenu bouge à chaque règle ajoutée ou retirée, et l'organisateur
 * doit voir l'effet immédiatement. Un `<style>` ordinaire se re-rend comme n'importe
 * quel nœud.
 *
 * Le CSS ne se soucie pas d'où sa balise se trouve : posée ici, elle s'applique au
 * document entier. C'est justement pour ça que `pourInjection` confine chaque règle
 * sous `.site` — la position ne protège rien, le sélecteur si.
 *
 * ⚠️ IL VIT DANS `.site`, donc il disparaît avec lui. Un aperçu d'organisateur qui
 * quitte l'écran ne doit pas laisser derrière lui une feuille orpheline.
 */
export function CustomCss() {
  const { value } = useSettings();
  const preview = usePreviewCss();
  const raw = value(CUSTOM_CSS_KEY);
  const saved = typeof raw === "string" ? raw : "";

  /**
   * ⚠️ L'APERÇU EST FUSIONNÉ ICI, PAS POSÉ À CÔTÉ. Une règle qu'on essaie vise
   * généralement le même bloc qu'une règle déjà enregistrée : deux balises `<style>`
   * se départageraient à l'ordre du document — donc selon que le panneau est rendu
   * avant ou après le site, ce qui n'a rien à voir avec le sujet. Fusionné, l'essai
   * REMPLACE la règle de même sélecteur, exactement comme le fera l'acceptation. Ce
   * qu'on regarde est ce qu'on obtiendra.
   */
  const feuille = preview
    ? replaceRules(saved, preview.replaces, preview.css)
    : saved;

  if (feuille.trim() === "") return null;
  return <style>{forInjection(feuille)}</style>;
}
